<template>
  <crm-side-panel @handleClose="handleClose" :title="detail.name">
    <div class="side-panel-content">
      <div class="side-panel-buttons">
        <crm-button
          v-if="
            auth.cluesUpdate &&
              auth.cluesUpdate.toggleStatus &&
              detail.salesmanCode === userInfo.userUid
          "
          :size="'mini'"
          :text="'编辑'"
          @click="toEdit()"
        >
        </crm-button>
        <crm-button
          v-if="auth.cluesDelete && auth.cluesDelete.toggleStatus"
          :size="'mini'"
          :buttonType="'danger'"
          :text="'删除'"
          @click="handleDelete()"
        >
        </crm-button>
        <el-dropdown
          @command="handleUpdateState"
          v-if="
            [0, 1].includes(detail.cluesStatus) &&
              auth.cluesModifyState &&
              auth.cluesModifyState.toggleStatus
          "
          class="ml10"
        >
          <el-button type="warning" size="mini">
            更新状态<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              command="transfer"
              v-if="
                auth.cluesTransfer &&
                  auth.cluesTransfer.toggleStatus &&
                  !detail.customerId
              "
              >转化为客户</el-dropdown-item
            >
            <el-dropdown-item command="follow" v-if="detail.cluesStatus === 0"
              >跟进中</el-dropdown-item
            >
            <el-dropdown-item command="invalid">无效</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="side-panel-header">
        <!-- 头部信息 -->
        <div class="header-info">
          <div class="info-item">
            <p class="info-title">公司</p>
            <p class="info-detail">{{ detail.companyName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">来源</p>
            <p class="info-detail">{{ detail.cluesSourceName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">状态</p>
            <p class="info-detail">{{ detail.cluesStatus | statusFilter }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员</p>
            <p class="info-detail">{{ detail.salesmanName }}</p>
          </div>
          <div class="info-item">
            <p class="info-title">业务员所属部门</p>
            <p class="info-detail">{{ detail.teamName }}</p>
          </div>
        </div>
      </div>
      <div class="side-panel-tabs">
        <el-tabs v-model="activeTab" :stretch="false">
          <el-tab-pane label="详细信息" name="info" v-loading="loadingInfo">
            <pane-info :detail="detail" @toDetail="toCustomDetail"></pane-info>
          </el-tab-pane>
          <el-tab-pane
            label="拜访记录"
            name="visit"
            v-if="auth.cluesVisitTab && auth.cluesVisitTab.toggleStatus"
          >
            <div>
              <crm-button
                :size="'mini'"
                :text="'拜访'"
                class="fr mb10"
                @click="toVisit"
                v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              >
              </crm-button>
            </div>
            <!-- key更新组件 -->
            <pane-visit
              :id="id"
              :isCurrentTab="activeTab === 'visit'"
              :updatekey="updatekey"
            ></pane-visit>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <edit
      :visible="editVisible"
      :detail="detail"
      @close="editVisible = false"
      @success="handleEditSuccess()"
    >
    </edit>
    <transfer
      :visible="transferVisible"
      :customerUid="transferCusUid"
      :detail="detail"
      :cluesId="transferCluesId"
      :customName="detail.companyName"
      @close="
        transferVisible = false;
        transferCusUid = null;
      "
      @success="handleEditSuccess()"
    >
    </transfer>
    <el-dialog
      title="线索无效"
      width="30%"
      :visible.sync="invalidVisible"
      append-to-body
      @close="invalidVisible = false"
    >
      <el-form :model="invalidForm" label-width="120px" ref="form">
        <el-form-item
          label="无效原因:"
          prop="invalidReason"
          :rules="{
            required: true,
            message: '请选择无效原因',
            trigger: 'change',
          }"
        >
          <el-select
            clearable
            v-model="invalidForm.invalidReason"
            placeholder="请选择无效原因"
          >
            <el-option
              v-for="item in invalidReason"
              :label="item.name"
              :value="item.uid"
              :key="item.uid"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="invalidVisible = false"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleSaveInvalid()"></crm-button>
      </div>
    </el-dialog>

    <!-- 客户详情侧面板 -->
    <custom-detail
      v-show="customDetailShow"
      v-bind="viewPanel"
      @closeCustomDetail="customDetailShow = false"
    >
    </custom-detail>
    <!-- 新增 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @close="isAddVisitVisible = false"
      @success="updatekey = updatekey + 1"
    >
    </add-visit>
  </crm-side-panel>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CrmSidePanel from '~component/base/crmSidePanel.vue';
import CrmButton from '@/components/base/crmButton';
import Edit from '@/components/business/clue/edit.vue';
import Transfer from '@/components/business/clue/transfer.vue';
import PaneInfo from '@/components/business/clue/pane-info.vue';
import PaneVisit from '@/components/business/clue/pane-visit.vue';
import CustomDetail from '@/components/business/custom/customDetails.vue';
import AddVisit from '@/components/business/visit/addVisit';

export default {
  props: {
    id: String,
  },
  components: {
    Edit,
    Transfer,
    CrmSidePanel,
    CrmButton,
    PaneInfo,
    PaneVisit,
    CustomDetail,
    AddVisit,
  },
  filters: {
    statusFilter(val) {
      const list = [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '跟进中',
          value: 1,
        },
        {
          label: '已转换',
          value: 2,
        },
        {
          label: '失效',
          value: 3,
        },
        {
          label: '其他',
          value: 4,
        },
      ];
      const target = list.find(item => item.value === val);
      return target ? target.label : '';
    },
  },
  data() {
    return {
      editVisible: false,
      activeTab: 'info',
      invalidVisible: false,
      invalidForm: {
        cluesStatus: 3,
        invalidReason: null,
      },
      transferVisible: false,
      transferCusUid: null,
      transferCluesId: null,
      customDetailShow: false,
      viewPanel: {},
      loadingInfo: false,
      isAddVisitVisible: false,
      visitDetail: {},
      updatekey: 0,
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      visitAuth: 'authority/visitAuth',
      customAuth: 'authority/customAuth',
      detail: 'clue/detail',
      invalidReason: 'common/invalidReason',
      searchCustomerList: 'clue/searchCustomerList',
      webCustomerAuth: 'authority/webCustomerAuth',
      userInfo: 'authority/userInfo',
    }),
  },
  mounted() {
    this.getAuthority({ menuUrl: '/visit' });
    this.handleQueryDetail();
  },
  methods: {
    ...mapActions({
      getAuthority: 'authority/getAuthority',
      deleteClue: 'clue/deleteClue',
      getClueDetail: 'clue/getClueDetail',
      getInvalidReason: 'common/getInvalidReason',
      changeClue: 'clue/changeClue',
      searchCustomer: 'clue/searchCustomer',
    }),
    handleUpdateState(command) {
      if (command === 'transfer') this.toTransfer();
      if (command === 'follow') this.handleFollow();
      if (command === 'invalid') this.toInvalid();
    },
    toTransfer() {
      this.searchCustomer({
        customerName: this.detail.companyName,
        pageNumber: 1,
        pageSize: 10,
      }).then(() => {
        this.transferVisible = true;
        this.transferCluesId = this.detail.id;
        this.transferCusUid = null;
        const results = this.searchCustomerList.results;
        if (results.length) this.transferCusUid = results[0].uid;
      });
    },
    handleFollow() {
      this.$confirm('是否确认更新状态为跟进中？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.changeClue({
            id: this.id,
            cluesStatus: 1,
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: '更改成功!',
              });
              this.handleQueryDetail();
              this.$emit('refresh');
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    toInvalid() {
      this.invalidVisible = true;
      if (this.$refs.form) this.$refs.form.resetFields();
      this.getInvalidReason({
        pageSize: 100,
        pageNumber: 1,
        code: 'category_invalid_reason',
      });
    },
    handleSaveInvalid() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.changeClue({
            id: this.id,
            ...this.invalidForm,
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: '更改成功!',
              });
              this.invalidVisible = false;
              this.handleQueryDetail();
              this.$emit('refresh');
            })
            .catch(() => {});
        }
      });
    },
    handleEditSuccess() {
      this.handleQueryDetail();
      this.$emit('refresh');
    },
    toEdit() {
      this.editVisible = true;
    },
    handleDelete() {
      this.$confirm('此操作将永久删除该线索, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteClue({ id: this.id })
            .then(() => {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.$emit('close');
              this.$emit('refresh');
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    handleClose() {
      this.$emit('close');
    },
    toCustomDetail() {
      if (this.detail.customerIsDeleted) {
        this.$message.error('该客户已被删除');
      } else {
        this.customDetailShow = true;
        this.viewPanel = {
          uid: this.detail.customerId,
          authEdit: this.customAuth.customerAdd.toggleStatus,
          authDelete: this.customAuth.customerDelete.toggleStatus,
        };
      }
    },
    handleQueryDetail() {
      this.loadingInfo = true;
      this.getClueDetail({ id: this.id }).finally(() => {
        this.loadingInfo = false;
      });
    },
    // 拜访
    toVisit() {
      this.visitDetail = {
        visitObject: 3,
        visitObjectId: this.detail.id,
        cluesName: this.detail.name,
        cluesId: this.detail.id,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: false,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
      console.log(this.visitDetail, 'this.visitDetail');
    },
  },
};
</script>

<style lang="less">
.el-dropdown-menu .el-dropdown-menu__item {
  cursor: pointer;
}
</style>
